export const SourceProviderColor = [
  { provider: "maputnik", color: "#C6DBDA" },
  { provider: "maptiler", color: "#FEE1E8" },
  { provider: "thunderforest", color: "#FED7C3" },
  { provider: "mapbox", color: "#F6EAC2" },
];
